export enum TariffManagementEnum {
  zoneCities = 'RATING_Mexico_Cities'
};
